export default __webpack_public_path__ + "static/media/3-certificacoes.078b54f3.svg";